document.addEventListener('DOMContentLoaded', () => {
  const oldElement = document.getElementById('main-content');

  if (oldElement) {
    const newElement = document.createElement('main');

    // Copy attributes
    for (let i = 0; i < oldElement.attributes.length; i++) {
      const attr = oldElement.attributes[i];
      newElement.setAttribute(attr.name, attr.value);
    }

    // Move child nodes
    while (oldElement.firstChild) {
      newElement.appendChild(oldElement.firstChild);
    }

    // Replace old element
    oldElement.parentNode.replaceChild(newElement, oldElement);
  }
});
